import { render, staticRenderFns } from "./calification-button.vue?vue&type=template&id=8cf94d16&scoped=true"
import script from "./calification-button.vue?vue&type=script&lang=js"
export * from "./calification-button.vue?vue&type=script&lang=js"
import style0 from "./calification-button.vue?vue&type=style&index=0&id=8cf94d16&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8cf94d16",
  null
  
)

export default component.exports